module.exports = __webpack_public_path__ + "media/Ds.46c9bd68.wav";